<div class="container-fluid">
  <div class="row justify-content-center">
    <div class="col-11 w3-center">
      <img src="../assets/images/bsflogo.png" class="img-circle" alt="BRR" style="max-height: 80px;margin-top: 5px;">
      <div class="w3-center w3-xlarge" style="font-weight: bolder;">
        Buriram Sugar Public Co., Ltd.
      </div>
      <div class="w3-center w3-large" style="font-weight: bolder;">
        ปริมาณหีบอ้อยรายชั่วโมงปี {{ yearLabelTh! }}
      </div>
      <div class="w3-center">
        <mat-form-field appearance="outline" style="max-width: 250px;">
          <mat-label>เลือกวันที่ </mat-label>
          <input matInput [matDatepicker]="dp3" disabled [(ngModel)]="date2" (ngModelChange)="reload()">
          <mat-datepicker-toggle matSuffix [for]=" dp3"></mat-datepicker-toggle>
          <mat-datepicker #dp3 disabled="false"></mat-datepicker>
        </mat-form-field>
      </div>
    </div>
    <mat-progress-bar mode="indeterminate" *ngIf="loading[0]"></mat-progress-bar>
  </div>
</div>

<!-- <div class="row">
    <div class="col-md-2 text-center align-content-center" style="padding-top: auto;">
      <img src="../assets/images/bsflogo.png" class="img-circle" alt="Logo BRD Image" style="width:min-content;">
    </div>
    <div class="col-md-3"> <br>
      Buriram Sugar Public Co., Ltd.
      <br><i class="fas fa-chart-area"></i> <span class="text-primary"> ปริมาณหีบอ้อยรายชั่วโมงปี {{ yearLabelTh! }} </span>
    </div>
    <div class="col-md-auto align-content-center">
      <p>
        <mat-form-field appearance="outline">
          <mat-label>เลือกวันที่ </mat-label>
          <input matInput [matDatepicker]="dp3" disabled  [(ngModel)]="date2"
            (ngModelChange)="reload()">
          <mat-datepicker-toggle matSuffix [for]="dp3"></mat-datepicker-toggle>
          <mat-datepicker #dp3 disabled="false"></mat-datepicker>
        </mat-form-field>
      </p>
    </div>
  </div> -->

<div class="container-fluid">
  <div class="card card-outline card-primary">
    <div class="card-header">
      <span class="card-title">ประจำวันที่ {{ date2 | adtob }} </span>
      <div class="card-tools">
        <button type="button" class="btn btn-tool" (click)="reload();">
          <i class="fas fa-sync"></i>
        </button>
        <button type="button" class="btn btn-tool" (click)="ExportExcel();">
          <i class="fas fa-file-excel"></i>
        </button>
        <button type="button" class="btn btn-tool" data-card-widget="collapse">
          <i class="fas fa-minus"></i>
        </button>

      </div>
      <!-- /.card-tools -->
    </div>
    <!-- /.card-header -->
    <div class="card-body">
      <!-- ปกติ -->
      <div class="row justify-content-md-center">
        <mat-progress-bar mode="indeterminate" *ngIf="loading[1]"></mat-progress-bar>
        <!-- คิวล็อค -->
        <div class="col-md-auto" *ngFor="let item of datacar1">
          <div class="info-box bg-blue">
            <span class="info-box-icon"><i class="fa fa-heartbeat"></i></span>
            <div class="info-box-content">
              <span class="info-box-text">คิวล็อค</span>
              <span class="info-box-number">{{item.wgtnet | number}}</span>
              <div class="progress">
                <div class="progress-bar" [ngStyle]="{'width': item.pccane+'%'}"></div>
              </div>
              <span class="progress-description">
                {{item.pccane}}% Target {{item.caneperdate | number}}
              </span>
            </div>
            <!-- /.info-box-content -->
          </div>
        </div>
        <!-- คิวรถโยน -->
        <div class="col-md-auto" *ngFor="let item of datacar2">
          <div class="info-box bg-yellow">
            <span class="info-box-icon"><i class="fa fa-child"></i></span>

            <div class="info-box-content">
              <span class="info-box-text">คิวรถโยน</span>
              <span class="info-box-number">{{item.wgtnet | number}}</span>

              <div class="progress">
                <div class="progress-bar" [ngStyle]="{'width': item.pccane+'%'}"></div>
              </div>
              <span class="progress-description">
                {{item.pccane}}% Target {{item.caneperdate | number}}
              </span>
            </div>
            <!-- /.info-box-content -->
          </div>
        </div>
        <!-- คิวรถตัด -->
        <div class="col-md-auto" *ngFor="let item of datacar3">
          <div class="info-box bg-secondary">
            <span class="info-box-icon"><i class="fa fa-cut"></i></span>

            <div class="info-box-content">
              <span class="info-box-text">คิวรถตัด</span>
              <span class="info-box-number">{{item.wgtnet | number}}</span>

              <div class="progress">
                <div class="progress-bar" [ngStyle]="{'width': item.pccane+'%'}"></div>
              </div>
              <span class="progress-description">
                {{item.pccane}}% Target {{item.caneperdate | number}}
              </span>
            </div>
            <!-- /.info-box-content -->
          </div>
        </div>
        <!-- คิวรถลาน -->
        <div class="col-md-auto" *ngFor="let item of datacar4">
          <div class="info-box bg-fuchsia">
            <span class="info-box-icon"><i class="fa fa-truck"></i></span>

            <div class="info-box-content">
              <span class="info-box-text">คิวรถลาน</span>
              <span class="info-box-number">{{item.wgtnet | number}}</span>

              <div class="progress">
                <div class="progress-bar" [ngStyle]="{'width': item.pccane+'%'}"></div>
              </div>
              <span class="progress-description">
                {{item.pccane}}% Target {{item.caneperdate | number}}
              </span>
            </div>
            <!-- /.info-box-content -->
          </div>
        </div>

        <!-- ทางไกล -->
        <!-- คิวนางรอง -->
        <div class="col-md-auto" *ngFor="let item of datacar5">
          <div class="info-box bg-aqua">
            <span class="info-box-icon"><i class="far fa-share-square"></i></span>

            <div class="info-box-content">
              <span class="info-box-text">คิวนางรอง</span>
              <span class="info-box-number">{{item.wgtnet | number}}</span>

              <div class="progress">
                <div class="progress-bar" [ngStyle]="{'width': item.pccane+'%'}"></div>
              </div>
              <span class="progress-description">
                {{item.pccane}}% Target {{item.caneperdate | number}}
              </span>
            </div>
            <!-- /.info-box-content -->
          </div>
        </div>
        <!-- คิวนาโพธิ์ -->
        <div class="col-md-auto" *ngFor="let item of datacar6">
          <div class="info-box bg-maroon">
            <span class="info-box-icon"><i class="far fa-share-square"></i>
            </span>

            <div class="info-box-content">
              <span class="info-box-text">คิวนาโพธิ์</span>
              <span class="info-box-number">{{item.wgtnet | number}}</span>

              <div class="progress">
                <div class="progress-bar" [ngStyle]="{'width': item.pccane+'%'}"></div>
              </div>
              <span class="progress-description">
                {{item.pccane}}% Target {{item.caneperdate | number}}
              </span>
            </div>
            <!-- /.info-box-content -->
          </div>
        </div>

        <!-- คิวอ้อยสด -->
        <div class="col-md-auto" *ngFor="let item of datacar8">
          <div class="info-box bg-green">
            <span class="info-box-icon"><i class="fa fa-heart"></i></span>

            <div class="info-box-content">
              <span class="info-box-text">คิวอ้อยสด</span>
              <span class="info-box-number">{{item.wgtnet | number}}</span>

              <div class="progress">
                <div class="progress-bar" [ngStyle]="{'width': item.pccane+'%'}"></div>
              </div>
              <span class="progress-description">
                {{item.pccane}}% Target {{item.caneperdate | number}}
              </span>
            </div>
            <!-- /.info-box-content -->
          </div>
        </div>
        <!-- end row -->
        <div class="col-md-auto" *ngIf="datacarSum">
          <div class="info-box bg-green">
            <span class="info-box-icon"><i class="fa fa-heart"></i></span>
            <div class="info-box-content">
              <span class="info-box-text">รวม</span>
              <span class="info-box-number">{{datacarSum.wgtnet | number}}</span>

              <div class="progress">
                <div class="progress-bar" [ngStyle]="{'width': datacarSum.pccane+'%'}"></div>
              </div>
              <span class="progress-description">
                {{datacarSum.pccane | number}}% Target {{datacarSum.caneperdate | number}}
              </span>
            </div>
            <!-- /.info-box-content -->
          </div>
        </div>
        <!-- sum -->


        <br>
        <div class="card-body table-responsive p-2">
          <table #tb_canehour
            class="table table-hover table-striped table-head-fixed table-bordered text-nowrap table-sm"
            *ngIf="caneperhour.length>0">
            <thead>
              <tr class="text-center">
                <th class="sticky-col bg-light color-palette" style="position: sticky; top: 0;"> {{date2|adtob}}</th>
                <th colspan="2" class="bg-success disabled color-palette">ราง A</th>
                <th colspan="2" class="bg-danger disabled color-palette">ราง B</th>
                <th colspan="2" class="bg-primary disabled color-palette">รวม</th>

                <th colspan="2" class="bg-maroon disabled color-palette">คิวล็อค</th>
                <th colspan="2" class="bg-maroon disabled color-palette">คิวรถโยน</th>
                <th colspan="2" class="bg-maroon disabled color-palette">คิวรถตัด</th>
                <th colspan="2" class="bg-maroon disabled color-palette">คิวรถลาน</th>
                <th colspan="2" class="bg-maroon disabled color-palette">คิวโซน21</th>
                <th colspan="2" class="bg-maroon disabled color-palette">คิวโซน23</th>
              </tr>
              <tr class="text-center">
                <th class="sticky-col bg-primary">ชั่วโมงการผลิต</th>
                <th class="bg-success color-palette">จำนวนคัน </th>
                <th class="bg-success color-palette">ปริมาณอ้อย</th>
                <th class="bg-danger color-palette">จำนวนคัน</th>
                <th class="bg-danger color-palette">ปริมาณอ้อย</th>
                <th class="bg-primary color-palette">จำนวน(คัน)</th>
                <th class="bg-primary color-palette">ปริมาณอ้อย</th>

                <th class="bg-maroon color-palette" style="text-align:right">คัน</th>
                <th class="bg-maroon color-palette" style="text-align:left">ตัน</th>
                <th class="bg-maroon color-palette" style="text-align:right">คัน</th>
                <th class="bg-maroon color-palette" style="text-align:left">ตัน</th>
                <th class="bg-maroon color-palette" style="text-align:right">คัน</th>
                <th class="bg-maroon color-palette" style="text-align:left">ตัน</th>
                <th class="bg-maroon color-palette" style="text-align:right">คัน</th>
                <th class="bg-maroon color-palette" style="text-align:left">ตัน</th>
                <th class="bg-maroon color-palette" style="text-align:right">คัน</th>
                <th class="bg-maroon color-palette" style="text-align:left">ตัน</th>
                <th class="bg-maroon color-palette" style="text-align:right">คัน</th>
                <th class="bg-maroon color-palette" style="text-align:left">ตัน</th>
              </tr>
              <tr class="text-center under">
                <td class="sticky-col bg-primary">++ รวม</td>
                <td class="bg-success disabled color-palette">{{sumdata.cntcaneA || 0 | number}}</td>
                <td class="bg-success disabled color-palette">{{sumdata.sumcaneA || 0 | number}}</td>
                <td class="bg-danger disabled color-palette">{{sumdata.cntcaneB || 0 | number}}</td>
                <td class="bg-danger disabled color-palette">{{sumdata.sumcaneB || 0 | number}}</td>
                <td class="bg-primary disabled color-palette">{{sumdata.cntall || 0 | number}}</td>
                <td class="bg-primary disabled color-palette">{{sumdata.sumall || 0 | number}}</td>

                <td class="bg-maroon disabled color-palette" style="text-align:right">{{sumdata.cntcaneTq1 || 0 |
                  number}}</td>
                <td class="bg-maroon disabled color-palette" style="text-align:left">{{sumdata.sumcaneTq1 || 0 |
                  number}}</td>
                <td class="bg-maroon disabled color-palette" style="text-align:right">{{sumdata.cntcaneTq2 || 0 |
                  number}}</td>
                <td class="bg-maroon disabled color-palette" style="text-align:left">{{sumdata.sumcaneTq2 || 0 |
                  number}}</td>
                <td class="bg-maroon disabled color-palette" style="text-align:right">{{sumdata.cntcaneTq3 || 0 |
                  number}}</td>
                <td class="bg-maroon disabled color-palette" style="text-align:left">{{sumdata.sumcaneTq3 || 0 |
                  number}}</td>
                <td class="bg-maroon disabled color-palette" style="text-align:right">{{sumdata.cntcaneTq4 || 0 |
                  number}}</td>
                <td class="bg-maroon disabled color-palette" style="text-align:left">{{sumdata.sumcaneTq4 || 0 |
                  number}}</td>
                <td class="bg-maroon disabled color-palette" style="text-align:right">{{sumdata.cntcaneTq621 || 0 |
                  number}}</td>
                <td class="bg-maroon disabled color-palette" style="text-align:left">{{sumdata.sumcaneTq621 || 0 |
                  number}}</td>
                <td class="bg-maroon disabled color-palette" style="text-align:right">{{sumdata.cntcaneTq623 || 0 |
                  number}}</td>
                <td class="bg-maroon disabled color-palette" style="text-align:left">{{sumdata.sumcaneTq623 || 0 |
                  number}}</td>
              </tr>
            </thead>
            <tbody>
              <tr class="text-center" *ngFor="let h of caneperhour">
                <td class="sticky-col bg-secondary p-2 bg-opacity-80">{{h.canehour}}</td>
                <td>{{h.cntcaneA || 0 | number}}</td>
                <td>{{h.sumcaneA || 0 | number}}</td>
                <td>{{h.cntcaneB || 0 | number}}</td>
                <td>{{h.sumcaneB || 0 | number}}</td>
                <td>{{h.cntall || 0 | number}}</td>
                <td><label>{{h.sumall || 0 | number}}</label></td>
                <td style="text-align:right">{{h.cntcaneTq1 || 0 | number}}</td>
                <td style="text-align:left">{{h.sumcaneTq1 || 0 | number}}</td>
                <td style="text-align:right">{{h.cntcaneTq2 || 0 | number}}</td>
                <td style="text-align:left">{{h.sumcaneTq2 || 0 | number}}</td>
                <td style="text-align:right">{{h.cntcaneTq3 || 0 | number}}</td>
                <td style="text-align:left">{{h.sumcaneTq3 || 0 | number}}</td>
                <td style="text-align:right">{{h.cntcaneTq4 || 0 | number}}</td>
                <td style="text-align:left">{{h.sumcaneTq4 || 0 | number}}</td>
                <td style="text-align:right">{{h.cntcaneTq621 || 0 | number}}</td>
                <td style="text-align:left">{{h.sumcaneTq621 || 0 | number}}</td>
                <td style="text-align:right">{{h.cntcaneTq623 || 0 | number}}</td>
                <td style="text-align:left">{{h.sumcaneTq623 || 0 | number}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <!-- /.card-body -->
    </div>
    <!-- /.card -->
  </div>
</div>